module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-19-697c72c8184c1683949f389d1f9f45b8.jpg";